import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { Sun, Moon } from "lucide-react";
import { motion } from "framer-motion";

const NeumorphicThemeToggle = () => {
  let theme = "dark";
  let toggleTheme = () => {};
  
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
    toggleTheme = themeContext.toggleTheme;
  } catch {
    // Not within NeumorphicThemeProvider, use defaults
    return null;
  }

  return (
    <motion.button
      onClick={toggleTheme}
      className={`
        fixed bottom-24 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center
        transition-all duration-300 cursor-pointer
        ${theme === "dark" 
          ? "bg-[#0a0a0a] shadow-[10px_10px_20px_#000000,-10px_-10px_20px_#0d0d0d]" 
          : "bg-[#f5f5f5] shadow-[10px_10px_20px_#d8d8d8,-10px_-10px_20px_#fefefe]"
        }
        hover:scale-105 active:scale-95
      `}
      whileTap={{ scale: 0.9 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
    >
      {theme === "dark" ? (
        <Sun className="w-6 h-6 text-[#E4683B]" />
      ) : (
        <Moon className="w-6 h-6 text-[#1a1a1a]" />
      )}
    </motion.button>
  );
};

export default NeumorphicThemeToggle;
